import styled from 'styled-components';

import { StyleColor, NewStyleColor } from '../../../utils/styles-constants';
import { hexToRgba } from '../../../utils/style';

interface TableCellProps {
	as: string;
}

const StyledTable = styled('table')`
	width: 100%;
	border-collapse: collapse;
	color: ${StyleColor.Grey450};
`;

const TableCell = styled('td')`
	box-sizing: border-box;
	position: relative;
	width: 10%;
	height: ${(props: TableCellProps) => props.as === 'th' ? '30px' : '62px'};
	padding: 4px;

	&:first-child {
		width: 1%;
	}

	&:nth-child(2) {
		width: 50%;
	}

	&::after {
		content: '';
		position: absolute;
		left: 0;
		right: 0;
		bottom: 0;
		border-bottom: 1px solid ${hexToRgba(StyleColor.Grey450, 17)};

		tbody tr:last-child & {
			border: 0;
		}
	}

	${(props: TableCellProps) => props.as === 'th' && `
		position: sticky;
		top: 0;
		z-index: 1;
		background-color: ${StyleColor.White};
	`}
`;

const TableCellInner = styled('div')`
	position: relative;
	height: 100%;
`;

const TableCellInnerContent = styled('div')`
	position: absolute;
	top: 50%;
	left: 0;
	right: 0;
	transform: translateY(-50%);
`;

const Label = styled('div')`
	font-size: 17px;
	line-height: 20px;
	color: ${NewStyleColor.Grey800};
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
`;

const Email = styled('div')`
	font-size: 11px;
	line-height: 14px;
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
`;

export {
	StyledTable,
	TableCell,
	TableCellInner,
	TableCellInnerContent,
	Label,
	Email,
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ProposalStatsPage/Table/styles.ts